import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import PricingOptions from "./PricingOptions"; // Adjust the import path as necessary
import { Category, ImageUrl, Package, PricingModel } from "../CRUD/CampSites/types"; // Adjust the import path as necessary

interface PackageFormProps {
  categories: Category[];
  handlePackageSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onSubmit: (data: any) => void;
  onCancel: () => void;
  imageUrls: ImageUrl[];
  getRootProps: any;
  getInputProps: any;
  mainImageIndex: number | null;
  setMainImageIndex: (index: number) => void;
  setImageUrls: (imageUrls: ImageUrl[]) => void;
  initialName?: string;
  initialLocation?: string;
  initialCapacity?: number;
  initialDescription?: string;
  initialPrice?: number;
  initialImageUrls?: ImageUrl[];
  isEditing: boolean;
  packageId?: number;
  packageDto?: Package;
  packageDetails: any;
  pricingOptions: PricingModel[];
  dateRanges: { startDate: Date; endDate: Date }[];
  setDateRanges: (dateRanges: { startDate: Date; endDate: Date }[]) => void;
  setPackageDetails: (data: any) => void;
  setPricingOptions: (pricingOptions: PricingModel[]) => void;
}

const PackageForm: React.FC<PackageFormProps> = ({
  onSubmit,
  mainImageIndex,
  setMainImageIndex,
  initialName = "",
  initialLocation = "",
  initialCapacity = 0,
  initialDescription = "",
  initialPrice = 0,
  initialImageUrls = [],
  isEditing = false,
  packageId,
  packageDto,
  packageDetails,
  
 
  onCancel,
  categories: initialCategories,



}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [name, setName] = useState(initialName);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [location, setLocation] = useState(initialLocation);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [capacity, setCapacity] = useState(initialCapacity);
  const [description, setDescription] = useState(initialDescription);
  const [imageUrls, setImageUrls] = useState<ImageUrl[]>(initialImageUrls);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pricePerNight, setPricePerNight] = useState(initialPrice);
  const [categoryId, setCategoryId] = useState<number | null>(null);
  const [categoryName, setCategoryName] = useState<string | null>(null);
  const [categories, setCategories] = useState<Category[]>(initialCategories);
  const [price, setPrice] = useState<number>(0);
  const [maxGroupSize, setMaxGroupSize] = useState<number | null>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [pricingOptions, setPricingOptions] = useState<any[]>([]);
  const [dateRanges, setDateRanges] = useState<any[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [nameError, setNameError] = useState<string | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [priceError, setPriceError] = useState<string | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [locationError, setLocationError] = useState<string | null>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [capacityError, setCapacityError] = useState<string | null>(null);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [descriptionError, setDescriptionError] = useState<string | null>(null);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pricePerNightError, setPricePerNightError] = useState<string | null>(null);
  const token = localStorage.getItem("accessToken");
  const { id } = useParams<{ id: string }>();
  const locationState = useLocation().state as { isEditing: boolean; package?: any };

  const [packageUrl, setPackageUrl] = useState<string>("");

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get<{ success: boolean; message: string | null; data: Category[] }>(`${apiUrl}/Category/getCategories`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          console.error('Error fetching categories:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, [apiUrl, token]);

  useEffect(() => {
    if (id) {
      // Fetch package details for editing
      axios.get<{ success: boolean; message: string | null; data: Package }>(`${apiUrl}/Package/getPackageById/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          console.log("Response:", response.data);
          const pkg = response.data.data;
          setName(pkg.name);
          setDescription(pkg.description);
          setCategoryId(pkg.categoryId ?? null);
          setCategoryName(pkg.categoryName);
          // setMaxGroupSize(pkg.maxGroupSize ?? null);
          setPrice(pkg.priceFrom);
 
         
          setPricingOptions(pkg.prices);

          // Extract date ranges from pricing options
          const extractedDateRanges = pkg.prices.map((price: any) => ({
            startDate: new Date(price.startDate),
            endDate: new Date(price.endDate),
          }));
          setDateRanges(extractedDateRanges);

        })
        .catch((error) => {
          console.error("Error fetching package details:", error);
        });
    }
  }, [id, apiUrl, token]);


  const sortedImageUrls = [...imageUrls].sort((a, b) => (b.isMain ? -1 : 1));

  useEffect(() => {
    if (isEditing && locationState && locationState.package) {
      const pkg = locationState.package;
      setName(pkg.name);
      setDescription(pkg.description);
      setCategoryId(pkg.categoryId);
      setCategoryName(pkg.categoryName);
      setMaxGroupSize(pkg.maxGroupSize);
      setPrice(pkg.priceFrom);
      setImageUrls(pkg.imageUrls);
      setMainImageIndex(pkg.imageUrls.findIndex((img: any) => img.isMain));
      setPricingOptions(pkg.prices);
      console.log("Pricing options:", pkg.prices);

      // Extract date ranges from pricing options
      const extractedDateRanges = pkg.prices.map((price: any) => ({
        startDate: new Date(price.startDate),
        endDate: new Date(price.endDate),
      }));
      setDateRanges(extractedDateRanges);

      console.log("Package from location state:", locationState.package);
    }
  }, [isEditing, locationState]);

  const handleRemoveImageUrl = async (imageUrl: string, packageId: number) => {
    try {
      const requestUrl = `${apiUrl}/CampSite/deletecampsiteImage/${packageId}`;
      console.log(`Request URL: ${requestUrl}`);
      console.log(`Request Params: imageUrl=${imageUrl}`);

      const response = await axios.delete(requestUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        params: { imageUrl },
      });
      console.log("Image delete response from backend:", response.data);

      const newImageUrls = imageUrls.filter((img) => img.url !== imageUrl);
      setImageUrls(newImageUrls);
    } catch (error: any) {
      console.error("Error deleting image", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
    }
  };

  const handleFileUpload = (files: File[]) => {
    const newImageUrls = [...imageUrls];
    const newSelectedFiles = [...selectedFiles];

    files.forEach((file, index) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        newImageUrls.push({ id: newImageUrls.length, url: reader.result as string, isMain: false });
        newSelectedFiles.push(file);
        setImageUrls([...newImageUrls]);
        setSelectedFiles([...newSelectedFiles]);
      };
      reader.readAsDataURL(file);
    });
  };

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      handleFileUpload(acceptedFiles);
    },
    [imageUrls, selectedFiles]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });



  console.log("imageUrls:", imageUrls);
  console.log("sortedImageUrls:", sortedImageUrls);

 const handlePackageSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const packageDto = {
        name,
        description,
        categoryId,
        categoryName,
        priceFrom: price,
        maxGroupSize,
        mainImageIndex,
        imageUrls,
        packageUrl, // Include packageUrl in the payload
    };

    const formData = new FormData();
    formData.append("packageDto", JSON.stringify(packageDto));
    formData.append("prices", JSON.stringify(pricingOptions));
    console.log("Form data:", formData);

    if (mainImageIndex !== null) {
        formData.append("mainImageIndex", mainImageIndex.toString());
    }

    selectedFiles.forEach((file) => {
        formData.append("newImages", file);
    });

    let response;
    if (isEditing) {
        response = await axios.put(
            `${apiUrl}/Package/updatePackage/${locationState.package.id}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
            }
        );
    } else {
        response = await axios.post(
            `${apiUrl}/Package/addPackage`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
            }
        );
    }

  
};

  const handleCancel = () => {
    navigate("/packageManager");
  };

 
  return (
    <section className="container packageForm-section mb-5 pb-5">
      <form onSubmit={handlePackageSubmit} className="packageForm">
        <div className="form-group">
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="category" className="form-label">Category</label>
          <select
            className="form-control"
            id="category"
            value={categoryId || ""}
            onChange={(e) => {
              const selectedCategoryId = parseInt(e.target.value, 10);
              setCategoryId(selectedCategoryId);
              const selectedCategory = categories.find(category => category.id === selectedCategoryId);
              if (selectedCategory) {
                setCategoryName(selectedCategory.name);
              }
            }}
            required
          >
            <option value="">Select a category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="description" className="form-label">Description</label>
          <input
            type="text"
            className="form-control"
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="priceFrom" className="form-label">Price From</label>
          <input
            type="number"
            className="form-control"
            id="priceFrom"
            value={price || ''}
            onChange={(e) => setPrice(parseFloat(e.target.value))}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="maxGroupSize" className="form-label">Max Group Size</label>
          <input
            type="number"
            className="form-control"
            id="maxGroupSize"
            value={maxGroupSize || ''}
            onChange={(e) => setMaxGroupSize(parseInt(e.target.value, 10))}
          />
        </div>
        <div className="form-group package-url-group">
          <label htmlFor="packageUrl" className="form-label">Package URL</label>
          <input
            type="text"
            className="form-control"
            id="packageUrl"
            value={packageUrl}
            onChange={(e) => setPackageUrl(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label className="form-label">Images</label>
          {imageUrls.map((img: any, index: any) => (
            <div key={index} className="input-group">
              <img
                src={img.url}
                alt={`Preview ${index}`}
                className={`img-thumbnail ${img.isMain ? "border border-primary" : ""}`}
              />
              <button
                type="button"
                className="button button-danger"
                onClick={() => handleRemoveImageUrl(img.url, packageId || 0)}
              >
                Remove
              </button>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="mainImage"
                  id={`mainImage${index}`}
                  checked={mainImageIndex === index}
                  onChange={() => {
                    setMainImageIndex(index);
                    const updatedImageUrls = imageUrls.map((img: any, imgIndex: any) => ({
                      ...img,
                      isMain: imgIndex === index,
                    }));
                    setImageUrls(updatedImageUrls);
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor={`mainImage${index}`}
                >
                  Main Image
                </label>
              </div>
            </div>
          ))}
          {imageUrls.length < 5 && (
            <div
              {...getRootProps({ className: "dropzone" })}
              className="input-group"
            >
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
          )}
        </div>
        <PricingOptions
          dateRanges={dateRanges}
          handleDateRangeChange={(index, field, value) => {
            console.log("Date range change:", index, field, value);
            const updatedDateRanges = [...dateRanges];
            updatedDateRanges[index] = {
              ...updatedDateRanges[index],
              [field]: value,
            };
            setDateRanges(updatedDateRanges);

            // Update the corresponding pricing option with the new date range
            const updatedPricingOptions = [...pricingOptions];
            updatedPricingOptions[index] = {
              ...updatedPricingOptions[index],
              startDate: updatedDateRanges[index].startDate,
              endDate: updatedDateRanges[index].endDate,
            };
            setPricingOptions(updatedPricingOptions);
            console.log("Updated pricing options with date ranges:", updatedPricingOptions);
          }}
          removeDateRange={(index) => {
            const updatedDateRanges = dateRanges.filter((_, i) => i !== index);
            setDateRanges(updatedDateRanges);
          }}
          addDateRange={() => {
            setDateRanges([...dateRanges, { startDate: new Date(), endDate: new Date() }]);
          }}
          pricingOptions={pricingOptions}
          handlePricingOptionChange={(pricingIndex: number, field: string, value: any) => {
            const updatedPricingOptions = [...pricingOptions];
            updatedPricingOptions[pricingIndex] = {
              ...updatedPricingOptions[pricingIndex],
              [field]: value,
            };
            console.log("Updated pricing options:", updatedPricingOptions);
            setPricingOptions(updatedPricingOptions);
          }}
          removePricingOption={(pricingIndex) => {
            const updatedPricingOptions = pricingOptions.filter((_, i) => i !== pricingIndex);
            setPricingOptions(updatedPricingOptions);
          }}
          addPricingOption={() => {
            setPricingOptions([
              ...pricingOptions,
              {
                id: 0,
                packageId: 0,
                package: {} as Package,
                description: '',
                price: 0,
                discount: 0,
                minPersons: 1,
                maxPersons: 4,
                startDate: new Date(),
                endDate: new Date(),
                priceFrom: 0,
              },
            ]);
          }}
        />
        <div className="button-area mb-5 pb-5">
          <button type="submit" className="btn btn-outline-success">
            {isEditing ? "Update" : "Add"} Package
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
};

export default PackageForm;
